import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProjectEditFormSubmissionViewTopBar } from "./TopBar"

export const projectEditFormSubmissionViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProjectEditFormSubmissionViewTopBar,
}
